export enum EFrontElement
{
    /// <summary>
    /// None
    /// </summary>
    NONE = 0,
    /// <summary>
    /// Door
    /// </summary>
    D = 1,
    /// <summary>
    /// Pull out
    /// </summary>
    PO = 2,
    /// <summary>
    /// Drawer
    /// </summary>
    DR = 3,
    /// <summary>
    /// Panel
    /// </summary>
    P = 4,
    /// <summary>
    /// Empty
    /// </summary>
    E = 5,
    /// <summary>
    /// Shutter
    /// </summary>
    SH = 6,
    /// <summary>
    /// Frame
    /// </summary>
    F = 7,
    /// <summary>
    /// Horizontal groove
    /// </summary>
    G = 8,
}


export class EFrontElementExtension {
    public static getName(element: EFrontElement): string {
        switch (element) {
            case EFrontElement.D:
                return "Door";
            case EFrontElement.PO:
                return "PullOut";
            case EFrontElement.DR:
                return "Drawer";
            case EFrontElement.P:
                return "Panel";
            case EFrontElement.E:
                return "Empty";
            case EFrontElement.SH:
                return "Shutter";
            case EFrontElement.F:
                return "Frame";
            case EFrontElement.G:
                return "Groove";
            default:
                return "NONE";
        }
    }
}